import React from "react";
import { Link } from "react-router-dom";

const services = [
  {
    id: "renovation",
    title: "Home Renovation & Construction Services",
    tagline: "Full-service renovation contractor in Kuala Lumpur & Selangor",
    image: "/img/images/services_img01.png",
    intro:
      "FRG Renovation Works is a trusted home renovation contractor in Malaysia delivering complete house renovation, kitchen renovation and home remodeling projects across Kuala Lumpur, Selangor and surrounding areas. Whether you're searching for a renovation contractor nearby for a single room or an end-to-end home renovation company for a full house upgrade, our licensed team brings experience, quality materials and transparent pricing to every job.",
    features: [
      "Kitchen renovation and bathroom remodeling",
      "Full house renovation & basement conversions",
      "In-home renovation & design consultation",
      "Property improvement services for residential and commercial buildings",
      "Custom carpentry, built-ins, flooring and ceiling works",
      "Construction and remodeling with eco-friendly materials",
    ],
    bottom:
      "From the best home renovation ideas for 2026 to complete house upgrade services, our team handles planning, design, permits and execution — so you get reliable repair and renovation solutions under one roof.",
  },
  {
    id: "electrition",
    title: "Licensed Electrical Handyman Services",
    tagline: "Safe, code-compliant electrical repair & installation",
    image: "/img/images/services_img04.png",
    intro:
      "Our licensed electrical handyman services cover everything from emergency handyman call-outs for faulty wiring to complete residential rewiring, panel upgrades and smart home installations. As a local home repair expert in Kuala Lumpur and Selangor, we follow strict Malaysian safety standards and provide honest, upfront quotes for every home maintenance service.",
    features: [
      "Emergency electrical home repair and fault-finding",
      "Wiring upgrades, panel replacement and circuit testing",
      "Lighting installation, dimmers and ceiling fan setups",
      "Power point additions, safety switches and surge protection",
      "Smart home & energy-efficient fittings",
      "Small home repair services for residential and commercial properties",
    ],
    bottom:
      "Looking for a reliable handyman near you for electrical work? Our licensed handyman services cover every aspect of residential repair so your home stays safe, compliant and energy-efficient.",
  },
  {
    id: "plumbing",
    title: "Plumbing & Home Repair Services",
    tagline: "Reliable plumbing from leaks to full installations",
    image: "/img/images/services_img03.png",
    intro:
      "FRG Renovation Works provides dependable plumbing services and home repair across Kuala Lumpur, Selangor and Malaysia. Whether you need an emergency handyman service for a burst pipe, a small home repair service for a dripping tap, or a full bathroom plumbing renovation, our experienced handymen deliver fast, clean, long-lasting repair and renovation solutions.",
    features: [
      "Emergency plumbing — leaks, blockages, burst pipes",
      "Water heater installation and repair",
      "Bathroom and kitchen plumbing remodeling",
      "Pipe replacement, drainage and clog clearing",
      "Fixture upgrades — taps, showers, toilets, sinks",
      "Licensed handyman services with 1-year workmanship warranty",
    ],
    bottom:
      "Every plumbing job is quoted upfront and completed by a licensed handyman — no hidden fees, no callback charges, just affordable home improvement you can count on.",
  },
  {
    id: "painting",
    title: "Interior & Exterior Painting Services",
    tagline: "Professional painting for homes, offices and commercial spaces",
    image: "/img/images/services_img02.png",
    intro:
      "Refresh your home or business with FRG Renovation Works' professional interior and exterior painting services across Kuala Lumpur and Selangor. Our skilled painters handle everything from single-room repainting as part of a house upgrade service to full commercial property improvement projects with weather-shielding coatings.",
    features: [
      "Interior painting — walls, ceilings, trim and mouldings",
      "Exterior painting with weather-shielding coatings",
      "Surface preparation, priming and defect repair",
      "Low-VOC, eco-friendly paint options",
      "Accent walls, textured finishes and custom colour consulting",
      "Residential repair experts for pre-sale and post-renovation painting",
    ],
    bottom:
      "From affordable home improvement tips to complete repaint jobs, our painting crew delivers flawless, long-lasting results — making us one of the most trusted local home improvement experts in Malaysia.",
  },
];

const ServicesDetailedArea = () => {
  return (
    <section className="services-detailed-area pt-130 pb-130">
      <div className="container">
        {/* Intro block */}
        <div className="row justify-content-center mb-80">
          <div className="col-lg-8">
            <div className="section-title text-center">
              <span className="sub-title">Our Services</span>
              <h2 className="title">
                Professional Handyman & Home Renovation Services in Malaysia
              </h2>
              <p className="services-detailed-intro">
                Explore our core handyman services in Kuala Lumpur, Selangor and across Malaysia — renovation, electrical, plumbing and painting — all delivered by licensed professionals with quality guarantees and transparent pricing.
              </p>
            </div>
          </div>
        </div>

        {/* Service blocks — alternating image side */}
        {services.map((s, i) => {
          const reverse = i % 2 === 1;
          return (
            <article
              key={s.id}
              id={s.id}
              className={`service-block ${reverse ? "service-block--reverse" : ""}`}
            >
              <div className="row align-items-center">
                <div className={`col-lg-6 ${reverse ? "order-lg-2" : ""}`}>
                  <div className="service-block__thumb">
                    <img src={s.image} alt={s.title} loading="lazy" />
                    <span className="service-block__badge">0{i + 1}</span>
                  </div>
                </div>

                <div className={`col-lg-6 ${reverse ? "order-lg-1" : ""}`}>
                  <div className="service-block__content">
                    <span className="service-block__tag">{s.tagline}</span>
                    <h3 className="service-block__title">{s.title}</h3>
                    <p className="service-block__intro">{s.intro}</p>

                    <ul className="service-block__features">
                      {s.features.map((f, idx) => (
                        <li key={idx}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="m5 12 5 5L20 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          <span>{f}</span>
                        </li>
                      ))}
                    </ul>

                    <p className="service-block__bottom">{s.bottom}</p>

                    <div className="service-block__cta">
                      <Link to="/contact" className="btn">
                        Get a Free Quote
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          );
        })}

        {/* Bottom CTA */}
        <div className="services-detailed-bottom">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h3 className="services-detailed-bottom__title">
                Need a Handyman Near You in Kuala Lumpur or Selangor?
              </h3>
              <p>
                From emergency handyman services and small home repair to complete home renovation and remodeling contractors — FRG Renovation Works is your one-stop local home improvement expert. Book a free on-site consultation today.
              </p>
              <div className="services-detailed-bottom__actions">
                <Link to="/contact" className="btn">
                  Book a Handyman
                </Link>
                <Link to="/services" className="btn btn-two">
                  View All Services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesDetailedArea;
